import { IDisposable } from './Disposable';
import { VideoSprite } from './VideoSprite';

export interface VideoOption {
  path: string;
  type: string;
}

export abstract class VideoData implements IDisposable {
  abstract dispose(): void;

  abstract preinit(): void;

  abstract play(looped: boolean): void;

  abstract stop(): void;

  abstract pause(): void;

  abstract resume(): void;

  abstract get isCanBePlayed(): boolean;

  abstract getSprite(): VideoSprite | null;

  abstract reset(): void;

  abstract prepareToPlay(): Promise<void>;

  abstract get videoOptions(): VideoOption[];

  // Creates an independent playback instance: same media, own video element
  // and own playhead. Used for per-scene-object playback of pooled resources.
  abstract clone(): VideoData;

  // Add any additional properties or methods here
}
